import {getAffiliatePoint} from '@web/actions/affiliatePoint'
import {APIStatus} from '@web/core/constants'
import makeSlice from '@web/slices/affiliatePoint/sliceMaker'

const affiliatePointSlice = makeSlice({
    extraReducers: (builder) => {
        builder
            .addCase(getAffiliatePoint.pending, (state) => {
                state.scene = APIStatus.FETCHING
            })
            .addCase(getAffiliatePoint.fulfilled, (state, {payload}) => {
                // https://wiki.navercorp.com/pages/viewpage.action?pageId=383758002
                // 299,999 를 대응합니다.
                const {body, resultCode, message} = payload
                state.amount = body ?? 0
                state.resultCode = resultCode
                state.message = message
                state.scene = APIStatus.RESOLVED
            })
            .addCase(getAffiliatePoint.rejected, (state) => {
                state.amount = 0
                state.scene = APIStatus.REJECTED
            })
    },
})

export default affiliatePointSlice.reducer
export const actions = {...affiliatePointSlice.actions}
